module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noselect tw-h-full",
    attrs: {
      "data-testid": "salarie-absenceSituation-section"
    }
  }, [(!_vm.ficheSalarie) ? _c('div', {
    staticClass: "area-salaried h-100 noselect section"
  }, [_c('div', {
    staticClass: "left-main",
    class: _vm.paieEnable ? 'extend' : 'mini'
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "bloc bloc-1",
    attrs: {
      "data-testid": "salarie-absenceSituation-N-1-section"
    }
  }, [_c('div', {
    staticClass: "head mb-2",
    attrs: {
      "data-testid": "salarie-absenceSituation-N-1-title"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCONGÉS PAYÉS -\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.anneeCouranteConges - 1) + " / " + _vm._s(_vm.anneeCouranteConges))])]), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "data-testid": "salarie-absenceSituation-N-1-card"
    }
  }, [(_vm.dataReady && _vm.compteurAbsences) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Acquis")]), _vm._v(" "), _c('div', {
    staticClass: "compteur"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPAcquis))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('div', {
    staticClass: "compteur"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPPris))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Restants")]), _vm._v(" "), _c('div', {
    staticClass: "compteur",
    class: _vm.compteurAbsences.CPRestantNMoins1 > 10 ? 'blue' : (_vm.compteurAbsences.CPRestantNMoins1 < 5 ? 'red' : 'yellow')
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.compteurAbsences.CPRestantNMoins1) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Prévi.")]), _vm._v(" "), _c('div', {
    staticClass: "compteur grey"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPRestantNMoins1Previsionnel))])])]) : _c('loader')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bloc bloc-2",
    attrs: {
      "data-testid": "salarie-absenceSituation-N-section"
    }
  }, [_c('div', {
    staticClass: "head mb-2",
    attrs: {
      "data-testid": "salarie-absenceSituation-N-title"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCONGÉS PAYÉS -\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.anneeCouranteConges) + " / " + _vm._s(_vm.anneeCouranteConges + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "data-testid": "salarie-absenceSituation-N-card"
    }
  }, [(_vm.dataReady && _vm.compteurAbsences) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Acquis")]), _vm._v(" "), _c('div', {
    staticClass: "compteur"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPDroitsOuverts))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('div', {
    staticClass: "compteur"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPPrisN))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Restants")]), _vm._v(" "), _c('div', {
    staticClass: "compteur",
    class: _vm.compteurAbsences.CPRestantN > 10 ? 'blue' : (_vm.compteurAbsences.CPRestantN < 5 ? 'red' : 'yellow')
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.compteurAbsences.CPRestantN) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Prévi.")]), _vm._v(" "), _c('div', {
    staticClass: "compteur grey"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPRestantNPrevisionnel))])])]) : _c('loader')], 1)]), _vm._v(" "), (_vm.paieEnable) ? _c('div', [_c('div', {
    staticClass: "bloc bloc-3",
    attrs: {
      "data-testid": "salarie-absenceSituation-RTT-section"
    }
  }, [_c('div', {
    staticClass: "head mb-2",
    attrs: {
      "data-testid": "salarie-absenceSituation-RTT-title"
    }
  }, [_vm._v("RTT")]), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "data-testid": "salarie-absenceSituation-RTT-card"
    }
  }, [(_vm.dataReady && _vm.compteurAbsences) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Acquis")]), _vm._v(" "), _c('div', {
    staticClass: "compteur"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.RTTAcquis))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('div', {
    staticClass: "compteur"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.RTTPris))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Restants")]), _vm._v(" "), _c('div', {
    staticClass: "compteur",
    class: _vm.compteurAbsences.RTTRestants > 10 ? 'blue' : (_vm.compteurAbsences.RTTRestants < 5 ? 'yellow' : 'red')
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.compteurAbsences.RTTRestants) + "\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Prévi.")]), _vm._v(" "), _c('div', {
    staticClass: "compteur grey"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.RTTPrevisionnel))])])]) : _c('loader')], 1)])]) : _vm._e()])])]) : _c('div', {
    staticClass: "tw-h-full"
  }, [_c('div', {
    staticClass: "title-head tw-mb-2"
  }, [_vm._v("Compteur des absences")]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "tw-border tw-border-gray-300 tw-shadow-lg tw-rounded tw-text-xl tw-flex tw-flex-col"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-h-[63px] tw-items-center tw-text-center tw-border-b tw-border-gray-200 tw-grow"
  }, [_c('div', {
    staticClass: "tw-w-[301px] tw-text-left tw-pl-2.5 tw-border-r tw-border-gray-200"
  }, [_c('div', {
    staticClass: "tw-text-sky-500 tw-font-light"
  }, [_vm._v("CONGÉS PAYÉS - " + _vm._s(_vm.anneeCouranteConges - 1) + " / " + _vm._s(_vm.anneeCouranteConges))])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPAcquis))]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPPris))]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200",
    class: [{
        'tw-text-blue-500': _vm.compteurAbsences.CPRestantNMoins1 > 10 || _vm.compteurAbsences.CPAcquis === 0
      },
      {
        'tw-text-amber-500': _vm.compteurAbsences.CPRestantNMoins1 <= 10 && _vm.compteurAbsences.CPRestantNMoins1 > 5 && _vm.compteurAbsences.CPAcquis !== 0
      },
      {
        'tw-text-red-500': _vm.compteurAbsences.CPRestantNMoins1 <= 5 && _vm.compteurAbsences.CPAcquis !== 0
      }
    ]
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPRestantNMoins1) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-blue-300"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPRestantNMoins1Previsionnel))])]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-h-[63px] tw-items-center tw-text-center tw-grow"
  }, [_c('div', {
    staticClass: "tw-w-[301px] tw-text-left tw-pl-2.5 tw-border-r tw-border-gray-200"
  }, [_c('div', {
    staticClass: "tw-text-sky-500 tw-font-light"
  }, [_vm._v("CONGÉS PAYÉS - " + _vm._s(_vm.anneeCouranteConges) + " / " + _vm._s(_vm.anneeCouranteConges + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPDroitsOuverts))]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPPrisN))]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200",
    class: [{
        'tw-text-blue-500': _vm.compteurAbsences.CPRestantN > 10 || _vm.compteurAbsences.CPDroitsOuverts === 0
      },
      {
        'tw-text-amber-500': _vm.compteurAbsences.CPRestantN <= 10 && _vm.compteurAbsences.CPRestantN > 5 && _vm.compteurAbsences.CPDroitsOuverts !== 0
      },
      {
        'tw-text-red-500': _vm.compteurAbsences.CPRestantN <= 5 && _vm.compteurAbsences.CPDroitsOuverts !== 0
      }
    ]
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPRestantN) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-blue-300"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.CPRestantNPrevisionnel))])]), _vm._v(" "), (_vm.paieEnable) ? _c('div', {
    staticClass: "tw-flex tw-h-[64px] tw-items-center tw-text-center tw-border-t tw-border-gray-200 tw-grow"
  }, [_c('div', {
    staticClass: "tw-w-[301px] tw-text-left tw-pl-2.5 tw-border-r tw-border-gray-200 tw-text-sky-500 tw-font-light"
  }, [_vm._v("RTT")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.RTTAcquis))]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.RTTPris))]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200",
    class: [{
        'tw-text-blue-500': _vm.compteurAbsences.RTTRestants > 10 || _vm.compteurAbsences.RTTAcquis === 0
      },
      {
        'tw-text-amber-500': _vm.compteurAbsences.RTTRestants <= 10 && _vm.compteurAbsences.RTTRestants > 5 && _vm.compteurAbsences.RTTAcquis !== 0
      },
      {
        'tw-text-red-500': _vm.compteurAbsences.RTTRestants <= 5 && _vm.compteurAbsences.RTTAcquis !== 0
      }
    ]
  }, [_vm._v(_vm._s(_vm.compteurAbsences.RTTRestants) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-blue-300"
  }, [_vm._v(_vm._s(_vm.compteurAbsences.RTTPrevisionnel))])]) : _vm._e()]) : _c('div', {
    staticClass: "tw-border tw-border-gray-300 tw-shadow-lg tw-rounded tw-text-xl tw-flex tw-flex-col"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tw-relative"
  }, [_c('Loader'), _vm._v(" "), _c('div', {
    staticClass: "tw-bg-black/10 tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.paieEnable) ? _c('div', {
    staticClass: "tw-flex tw-h-[64px] tw-items-center tw-text-center tw-border-t tw-border-gray-200 tw-grow"
  }, [_c('div', {
    staticClass: "tw-w-[301px] tw-text-left tw-pl-2.5 tw-border-r tw-border-gray-200 tw-text-sky-500 tw-font-light"
  }, [_vm._v("RTT")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-500"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-blue-300"
  }, [_vm._v("0")])]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-flex tw-h-10 tw-items-center tw-text-center tw-border-b-2 tw-border-gray-200"
  }, [_c('div', {
    staticClass: "tw-w-[301px]"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-border-x tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("Acquis")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-border-r tw-border-gray-200 tw-text-blue-500"
  }, [_vm._v("Restant")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-text-blue-300"
  }, [_vm._v("Prév.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-flex tw-h-10 tw-items-center tw-text-center tw-border-b-2 tw-border-gray-200"
  }, [_c('div', {
    staticClass: "tw-w-[301px]"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-border-x tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("Acquis")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-border-r tw-border-gray-200 tw-text-blue-500"
  }, [_vm._v("Restant")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-base tw-font-bold tw-text-blue-300"
  }, [_vm._v("Prév.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-flex tw-h-[63px] tw-items-center tw-text-center tw-border-b tw-border-gray-200 tw-grow"
  }, [_c('div', {
    staticClass: "tw-w-[301px] tw-text-left tw-pl-2.5 tw-border-r tw-border-gray-200"
  }, [_c('div', {
    staticClass: "tw-text-sky-500 tw-font-light"
  }, [_vm._v("CONGÉS PAYÉS - 20XX / 20XX")])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-500"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-blue-300"
  }, [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-flex tw-h-[63px] tw-items-center tw-text-center tw-grow"
  }, [_c('div', {
    staticClass: "tw-w-[301px] tw-text-left tw-pl-2.5 tw-border-r tw-border-gray-200"
  }, [_c('div', {
    staticClass: "tw-text-sky-500 tw-font-light"
  }, [_vm._v("CONGÉS PAYÉS - 20XX / 20XX")])]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-900"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-border-r tw-border-gray-200 tw-text-blue-500"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "tw-w-20 tw-text-blue-300"
  }, [_vm._v("0")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-763a5620"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/situationDesAbsences/tableaux/situationSalarie/situationSalarie.vue.html
// module id = OLCJ
// module chunks = 2